module.exports = __webpack_public_path__ + "img/39.d4f7257b.png";